import config from '@/config';
import axios from 'axios';

export const carServices = {
  namespaced: true,
  state: {
    services: [],
    chosenServices: [],
  },
  getters: {
    services(state) {
      return state.services;
    },
    chosenServices(state) {
      return state.chosenServices;
    },
  },
  mutations: {
    setServices(state, value) {
      state.services = value;
    },
    setChosenService(state, service) {
      state.chosenServices = [...state.chosenServices, service];
    },
    removeChosenService(state, service) {
      state.chosenServices = state.chosenServices.filter(chosenService => chosenService.id !== service.id);
    },
    resetChosenServices(state) {
      state.chosenServices = [];
    },
  },
  actions: {
    fetchCarServices({ commit, rootState }, value) {
      const parsedEndpoint = config.apiEndpoints.carServices.replace('id', value);
      const { selectedPartner } = rootState.visit;
      const id = selectedPartner ? selectedPartner.id : JSON.parse(sessionStorage.getItem('selectedPartner')).id;
      const params = {
        partner: id,
      };

      return new Promise((resolve, reject) => {
        axios.get(config.apiUrl + parsedEndpoint, { params })
          .then((res) => {
            if (res.status === 200) {
              commit('setServices', res.data);
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setChosenService({ commit }, service) {
      commit('setChosenService', service);
    },
    removeChosenService({ commit }, service) {
      commit('removeChosenService', service);
    },
    resetChosenServices({ commit }) {
      commit('resetChosenServices');
    },
  },
};
